import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '/ics/property/',
    routes: [
      {
        name: 'dailynewsHome',
        path: '/dailynews/:p1(industrial|office|shops)?',
        props: route => ({
          queryKeyword: route.query,
          articleType: 'daily_news',
        }),
        component: () => import('./article'),
      },
      {
        name: 'newsHome',
        path: '/news/:p1(industrial|office|shops)?',
        props: route => ({
          queryKeyword: route.query,
          articleType: 'ics_news',
        }),
        component: () => import('./article'),
      },
      {
        name: 'analysisHome',
        path: '/analysis/:p1(industrial|office|shops)?',
        props: route => ({
          queryKeyword: route.query,
          articleType: 'analysis',
        }),
        component: () => import('./article'),
      },
      {
        name: 'search',
        path: '/article/search/:p1(industrial|office|shops)?',
        props: route => ({
          queryKeyword: route.query,
          articleType: 'all',
        }),
        component: () => import('./article'),
      },
      {
        name: 'columnsHome',
        path: '/columns/:p1?',
        props: route => ({
          queryKeyword: route.query,
          articleType: 'columns',
        }),
        component: () => import('./article/columns'),
      },
      {
        name: 'icsGuide',
        path: '/ics_guide',
        props: route => ({
          queryKeyword: route.query,
          articleType: 'ics_guide',
        }),
        component: () => import('./article'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  return router;
};
